import React, { useEffect, useState } from "react";
import Banner from "../../components/public/Home/Banner";
import BannerImg from "../../../src/assets/images/bg_image_index.webp";
import BannerImgPNG from "../../../src/assets/images/bg_image_index.svg";
import Blog from "../../components/public/Home/Blogs";
import BusinessVerified from "../../components/public/Home/BusinessVerified";
import ClaimBusiness from "../../components/public/Home/claimBusiness";
import Companies from "../../components/public/Home/Companies";
import TrevexBenefits from "../../components/public/Home/TrevexBenefits";
import Testinomials from "../../components/public/Home/Testinomials";
import StayUpdated from "../../components/public/Home/StayUpdated";
import LogoBar from "../../components/public/Home/LogoBar";
import GPS from "../../components/public/Home/GPS";
import CreateProfile from "../../components/public/Home/createProfile";
import OurClient from "../../components/public/Home/OurClients";
import Footer from "../../../src/components/public/Footer";
import UserCheckPopUp from "../../components/common/UserCheckPopUp";
import TorchEffect from "../../components/torchEffect/TorchEffect";

const Home = ({ prompt = false }) => {
  const [showPopup, setShowPopup] = useState(false);
  useEffect(() => {
    localStorage.setItem("lastVisited", "");
    if (localStorage.getItem("UpgradePlan")) {
      localStorage.removeItem("UpgradePlan");
    }
  }, []);

  useEffect(() => {
    const jwtToken = localStorage.getItem('jwt');
    if (!jwtToken) {
      const popupState = sessionStorage.getItem('popup_shown');
      if (!popupState) {
        const timer = setTimeout(() => {
          setShowPopup(true);
        }, 1000);
        // Cleanup timer
        return () => clearTimeout(timer);
      }
    }
  }, []);

  const handleClosePopup = () => {
    sessionStorage.setItem('popup_shown', JSON.stringify(true));
    setShowPopup(false);
  };

  return (
    <div >
    <TorchEffect style={{backgroundColor: "rgba(0,0,0,0.4)", width:"100%"}}>
      {/* <TorchEffect/> */}
      <Banner prompt={prompt} />
    <div
      // style={{
        //   backgroundImage: `url("https://cdn.prod.website-files.com/67d0971bb0d647a225454bc8/67dc718bffe050fefc8177d2_pattern-white.png")`,
        //   backgroundPosition: prompt ? "center" : "top center",
        //   backgroundSize: prompt ? "cover" : "100%",
        //   backgroundRepeat: "no-repeat",
        //   width: "100%",
        //   height: prompt ? "100vh" : "auto",
        //   backgroundColor: "rgba(0,0,0,0.4)"
        // }}
        >
      
      {/* <UserCheckPopUp showPopup={showPopup} handleClosePopup={handleClosePopup} /> */}
    </div>
      </TorchEffect>
      {!prompt && <TrevexBenefits prompt={prompt} />}
      {!prompt && <><ClaimBusiness />
        <StayUpdated />
        <Testinomials />
        <div className="mt-12 sm:mt-[120px] bg-primary">
        <CreateProfile />
        </div>
        <Footer />
      </>}
    </div>
  );
};

export default Home;
